import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import type { Schema } from '../../schema';
import { FileField } from '@/components/react-hook-form/FileField';

export const Report: FC = () => {
  const {
    watch,
    setValue,
    formState: { errors }
  } = useFormContext<Schema>();

  const report = watch('report');

  return (
    <Panel>
      <Headding>健康診断結果ファイル</Headding>
      <Item>
        <FileField name="report" error={errors.report?.message}>
          {report && (
            <FileField.FileContainer>
              <FileField.File file={report} onRemove={() => setValue('report', null)} />
            </FileField.FileContainer>
          )}
        </FileField>
      </Item>
    </Panel>
  );
};
